// The product this page is (D125 A): the server names it on <html data-product> (lib/product.js productPage), and
// Canvas's page carries no attribute, so no attribute is Canvas. Every word that differs between Canvas and ClikMeet
// is here, so a screen asks `words` rather than choosing for itself.
import { PRODUCTS } from "../../lib/product.js";
import { firstName, h } from "./dom.js";

const named = document.documentElement.dataset.product || "canvas";
export const product = Object.hasOwn(PRODUCTS, named) ? PRODUCTS[named] : PRODUCTS.canvas;
export const isCanvas = product.id === "canvas";

// The product's wordmark, each wearing its mark: .canvas-brand from /icons/, .clikmeet-brand from /icons/clikmeet/ (26 Sep).
// Written out as literals: tests/unit/brand.test.mjs reads every brand in src/app for its mark.
export const wordmark = () => isCanvas
  ? h("span", { class: "brand canvas-brand" }, h("b", { text: "Walkin" }), h("span", { class: "by", text: " by Clikin.ai" }))
  : h("span", { class: "brand clikmeet-brand" }, h("b", { text: "Talkin" }), h("span", { class: "by", text: " by Clikin" }));

// The customer's own words on Canvas are the approved ones (docs/design-proposals/2026-09-19-canvas-words.html) and do
// not change here. ClikMeet is a meeting among colleagues and the people they invite.
export const words = isCanvas ? {
  hostLabel: "Sales manager",
  hostTile: "Sales manager",
  roles: { host: "Sales manager", customer: "Customer", guest: "Guest", rm: "Relationship manager" },
  askAgain: "Ask your relationship manager on WhatsApp",
  expired: "Meeting links work until a day after the meeting. Ask your relationship manager on WhatsApp for a fresh one.",
  gone: "Ask your relationship manager on WhatsApp if you need a new one.",
  eyebrow: (m) => ["The Right Life", m.project].filter(Boolean).join(" · "),
  statement: (m) => `Your meeting with ${firstName(m.hostName)}`,
  withLine: (m, isHost) => (isHost ? "Your customer, and anyone they invite" : `${m.hostName}, sales manager`),
  waitingHost: "Your customer's link is on their WhatsApp. They will appear here as soon as they join.",
  thanks: (you, m) => `${firstName(m.hostName)} and your Clikin.ai relationship manager will follow up with you on WhatsApp.`,
  thanksEnded: (you, m) => `${firstName(m.hostName)} has ended the meeting and will follow up with you on WhatsApp.`,
  removedBy: "The sales manager",
  owner: () => h("span", { class: "brand" }, h("b", { text: "The Right Life" }), " · Mana Skanda"),
  explore: { href: "https://mana.clikhome.in/", text: "Explore The Right Life", visit: "Visit The Right Life" },
  problemTitle: (t) => `${t} · The Right Life`,
} : {
  hostLabel: "Host",
  hostTile: "Host",
  // rm is a colleague ClikWork signed in on the room link (M3); guest, a knock the host admitted.
  roles: { host: "Host", customer: "Guest", guest: "Guest", rm: "Clikin" },
  askAgain: "Ask whoever invited you",
  expired: "Meeting links work until a day after the meeting. Ask whoever invited you for a fresh one.",
  gone: "Ask whoever invited you if you need a new one.",
  eyebrow: (m) => [product.name, m.project].filter(Boolean).join(" · "),
  statement: (m) => m.title || `Meeting with ${firstName(m.hostName)}`,
  withLine: (m, isHost) => (isHost ? "Everyone you sent a link to" : `${m.hostName}, host`),
  waitingHost: "Everyone you sent a link to will appear here as soon as they join.",
  thanks: () => "Thank you for joining.",
  thanksEnded: (you, m) => `${firstName(m.hostName)} has ended the meeting.`,
  removedBy: "The host",
  owner: () => wordmark(),
  explore: null,
  problemTitle: (t) => `${t} · ${product.name}`,
};
